module.exports = __webpack_public_path__ + "static/media/paragoncorp og.98d5977b.png";